export default {
  endpoint: "https://mainnet.mewwallet.dev",
};
